import React from "react";
import { motion } from "framer-motion";
import { useLang } from "../i18n/LanguageContext";

const STATS = [
  { num: "40+", key: "stats.years" },
  { num: "5 200+", key: "stats.projects" },
  { num: "4,5 / 5", key: "stats.rating" },
  { num: "220", key: "stats.reviews" },
];

export const StatsRibbon = () => {
  const { t } = useLang();
  return (
    <section className="bg-[#1A1A1A] text-[#F9F8F6] py-16 lg:py-20" data-testid="stats-ribbon">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 grid grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-6">
        {STATS.map((s, i) => (
          <motion.div
            key={s.key}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ delay: i * 0.08, duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
            className="flex flex-col gap-2"
            data-testid={`stat-${i}`}
          >
            <div className="font-display text-5xl lg:text-7xl font-light tabular tracking-tighter">{s.num}</div>
            <div className="text-xs lg:text-sm tracking-[0.2em] uppercase opacity-65">{t(s.key)}</div>
          </motion.div>
        ))}
      </div>
    </section>
  );
};
